import OverwritePolicy from './OverwritePolicy';
/**
 * Create a registry state from the given config
 * @param config
 */

export default function createRegistryState({
  globalId,
  name,
  version = '0.x.x',
  defaultKey,
  setFirstItemAsDefault = false,
  overwritePolicy = OverwritePolicy.ALLOW
}) {
  return {
    globalId,
    name,
    version,
    defaultKey,
    initialDefaultKey: defaultKey,
    setFirstItemAsDefault,
    overwritePolicy,
    items: {},
    promises: {}
  };
}